import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { parseISO, differenceInCalendarDays } from 'date-fns';

import Page from '@lwt-helix/page';
import { Button } from '@lwt-helix/buttons';

import {
    LinkSuccess,
    LinkGenericFailed,
    LinkAuthFailed,
    InvalidInvitationMessage
} from './SuccessAndFailureCases';
import { fetchInvitation, linkInvitationPatch } from '../../api/AuthenticationApi';
import Routes from '../../constants/Routes';
import { Status } from '../../constants/Invitations';

const LinkAccountLandingPage = () => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const [isSubmissionCompleted, setIsSubmissionCompleted] = useState(false);

    const { register, handleSubmit } = useForm();

    const linkSuccessful = useSelector(state => state.authenticationReducer.linkSuccess);
    const loading = useSelector(state => state.authenticationReducer.isLoading);
    const submitError = useSelector(state => state.authenticationReducer.error);
    const invitation = useSelector(state => state.authenticationReducer.invitation);

    useEffect(() => {
        dispatch(fetchInvitation(id));
    }, [id]);

    const handleRegistration = (data) => {
        dispatch(linkInvitationPatch(id, data.email, data.password));
    };

    useEffect(() => {
        if (invitation) {
            if (invitation.status?.toUpperCase() !== Status.INVITED
                || differenceInCalendarDays(new Date(), parseISO(invitation.date)) > 7) {
                setIsSubmissionCompleted(true);
            }
        }
    }, [invitation]);

    return (
        <>
            <Page fluid hero dataLwtId={'invitations-landing-page'}>
                {isSubmissionCompleted
                    ? <InvalidInvitationMessage />
                    : <form
                        className={'mx-auto my-6 rounded card-raised p-6 card card-body'}
                        style={{ minWidth: '50vw', width: '300px' }}
                        onSubmit={handleSubmit(handleRegistration)}
                    >
                        <img className="mx-auto mb-3" src="https://assets.lwolf.com/img/lw-logo-dark.svg" alt="Lone Wolf"
                            height="90" />
                        <h3 className="w-100 text-center">Link Your Lone Wolf Account</h3>
                        <hr className="my-4 border-top" />
                        {linkSuccessful ? <LinkSuccess /> :
                            <>
                                <div className="form-row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="email">Existing LWA Email Address</label>
                                            <input id="email" name="email" type="email"
                                                className="form-control-md form-control"
                                                {...register("email", { required: true, pattern: /^\S+@\S+$/i })}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="password">Password</label>
                                            <input id="password" name="password" type="password"
                                                className="form-control-md form-control"
                                                {...register("password", { required: true })}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <Button
                                    color="primary"
                                    type="submit"
                                    disabled={loading}
                                    style={{ width: "100%" }}
                                    dataLwtId={'link-account-button'}
                                >
                                    LINK ACCOUNT
                            </Button>

                                <div style={{ margin: "0 auto" }}>
                                    <a href={Routes.RESET_PASSWORD.replace(":id", id)}>Forgot Password? Click here to reset
                                    it.</a>
                                </div>
                            </>
                        }
                        {submitError == null ? null :
                            (submitError.response?.status === 404 && submitError.response?.data?.message === "Could not locate user") ?
                                <LinkAuthFailed /> :
                                <LinkGenericFailed />
                        }
                    </form>
                }
            </Page>
        </>
    )
};

export default LinkAccountLandingPage;

